let lockCount = 0;
let savedOverflow = '';

/**
 * Ref-counted body scroll lock.
 *
 * Layout shift is prevented globally via `scrollbar-gutter: stable` on `html`
 * (see styles/base/_reset.scss). Do not add padding-right here — that stacks
 * with the gutter and leaves a visible strip beside full-bleed content.
 */
export function lockBodyScroll(): void {
  if (typeof document === 'undefined') {
    return;
  }

  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  lockCount += 1;
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined') {
    return;
  }

  lockCount = Math.max(0, lockCount - 1);

  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow;
  }
}

/** @internal Test-only reset */
export function resetBodyScrollLockForTests(): void {
  lockCount = 0;
  savedOverflow = '';

  if (typeof document !== 'undefined') {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }
}
